import SearchLandingPage from './searchLandingPage';

export default SearchLandingPage;
